var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForegroundColorButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.49753 10.9672L3.38002 8.47393H6.62862L7.51112 10.9672H8.68778L5.57986 2.6665H4.44157L1.33366 10.9672H2.49753ZM5.02351 3.9192L6.32806 7.6165H3.68058L4.99153 3.9192H5.02351Z",
    fill: "#585858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5799 10.1705H13.6118V10.9672H14.667V6.55839C14.667 5.21447 13.6246 4.47258 12.1922 4.47258C10.5679 4.47258 9.76851 5.28745 9.69817 6.40636H10.7341C10.7981 5.76785 11.2905 5.34826 12.1538 5.34826C13.0619 5.34826 13.5735 5.81042 13.5735 6.64961V7.30028H11.8021C10.2609 7.30636 9.44237 8.01177 9.44237 9.13068C9.44237 10.3043 10.3377 11.0705 11.6358 11.0705C12.627 11.0705 13.2409 10.6874 13.5799 10.1705ZM11.93 10.201C11.2265 10.201 10.5679 9.84825 10.5679 9.0942C10.5679 8.51649 10.9644 8.10298 11.8852 8.10298H13.5735V8.84487C13.5735 9.64149 12.87 10.201 11.93 10.201Z",
    fill: "#585858"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.666992 12.8483C0.666992 12.5805 0.89085 12.3635 1.16699 12.3635H14.8337C15.1098 12.3635 15.3337 12.5805 15.3337 12.8483C15.3337 13.1161 15.1098 13.3332 14.8337 13.3332H1.16699C0.89085 13.3332 0.666992 13.1161 0.666992 12.8483Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForegroundColorButton);
export default __webpack_public_path__ + "static/media/foregroundColorButton.c91dc71a70019c5183229508d2e126ad.svg";
export { ForwardRef as ReactComponent };